const Themes = {
  DARK: 'dark',
  LIGHT: 'light',
  MIDNIGHT: 'midnight',
  DARKER: 'darker',
} as const;
type Themes = typeof Themes;

export const _private = {Themes};
